import { SearchIcon, Input, Box, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import ErrorBoundary from "../error/error-boundary";
import SalaryList from "./salary-list";
import { ChangeEvent, useState } from "react";
import { QueryKeys } from "../../types/query-key-enum";
import { invalidateQueries } from "../../query-client";
import Page from "../../components/page";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../hooks/use-user-context";

const SalaryRoot = () => {
	const { t } = useTranslation();
	const [isRefetching, setIsRefetching] = useState(false);
	const [searchText, setSearchText] = useState<string>("");
	const { systems } = useUserContext();
	const invalidate = () => {
		invalidateQueries([[QueryKeys.Salary]]);
	};

	const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchText(e.currentTarget.value.toLocaleLowerCase());
	};

	return (
		<Page
			title="salary"
			showFilter={systems.length > 1}
			reload={invalidate}
			reloadLoadingState={isRefetching}
			subheader
		>
			<>
				<Box mb={ThemeSpaceVariable.Medium}>
					<Input
						placeholder={t("search")}
						onChange={(e) => handleSearch(e)}
						value={searchText}
						leftElement={<SearchIcon />}
					/>
				</Box>
				<ErrorBoundary>
					<SalaryList setIsRefetching={setIsRefetching} searchText={searchText} />
				</ErrorBoundary>
			</>
		</Page>
	);
};

export default SalaryRoot;
